import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { menuTexts } from '../contexts/LangCompany';

const LANG_LABELS = {
  ko: 'ENGLISH',
  en: '한국어'
};

function Header() {
  const navigate = useNavigate();
  const { lang, setLang } = useLanguage();
  const [activeMenu, setActiveMenu] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const headerRef = useRef();

  // 창 크기 변경 감지
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 바깥 클릭 시 메뉴 닫기
  useEffect(() => {
    function handleClickOutside(e) {
      if (
        activeMenu &&
        headerRef.current &&
        !headerRef.current.contains(e.target)
      ) {
        setActiveMenu(null);
      }
      if (
        isMobileMenuOpen &&
        headerRef.current &&
        !headerRef.current.contains(e.target)
      ) {
        setIsMobileMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [activeMenu, isMobileMenuOpen]);

  const menuData = [
    {
      label: menuTexts[lang].company,
      link: '/company/about'
    },
    {
      label: menuTexts[lang].product,
      // link: '/product', // 추가: "제품" 클릭 시 이동할 경로
      sub: menuTexts[lang].productSub
    },
    {
      label: menuTexts[lang].contact,
      link: '/contactuse'
    }
  ];

  return (
    <header
      ref={headerRef}
      style={{
        padding: isMobile ? '15px 20px' : '20px 40px',
        borderBottom: '1px solid #eee',
        background: '#fff',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        maxWidth: '100vw',
        boxSizing: 'border-box',
        zIndex: 100
      }}
    >
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Link to="/" style={{ 
          fontWeight: 'bold', 
          fontSize: isMobile ? '1.3rem' : '1.5rem', 
          color: '#2b2b2b', 
          textDecoration: 'none' 
        }}>
          RIMAHR
        </Link>
        
        {/* 모바일 햄버거 메뉴 버튼 */}
        {isMobile && (
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1.5rem',
              cursor: 'pointer',
              padding: '5px',
              color: '#29225C'
            }}
          >
            ☰
          </button>
        )}
        
        {/* 데스크톱 네비게이션 */}
        <nav style={{ 
          display: isMobile ? 'none' : 'flex', 
          alignItems: 'center', 
          position: 'relative', 
          height: 60 
        }}>
          {menuData.map((menu, idx) => (
            <div key={menu.label} style={{ position: 'relative', height: '100%' }}>
              {menu.sub ? (
                <>
                  <button
                    style={{
                      margin: '0 16px',
                      color: '#29225C',
                      background: 'none',
                      border: 'none',
                      fontSize: '1.08rem',
                      fontWeight: 700,
                      cursor: 'pointer',
                      padding: 0,
                      height: '60px',
                      lineHeight: '60px',
                      textTransform: 'uppercase',
                      letterSpacing: '1.2px'
                    }}
                    onClick={() => {
                      // "제품" 메뉴 클릭 시 Hero-product.js 페이지로 이동 + 하위 메뉴 표시
                      navigate(menu.link);
                      setActiveMenu(menu.label);
                    }}
                  >
                    {menu.label}
                  </button>
                  {/* 하위 메뉴 표시 */}
                  {activeMenu === menu.label && menu.sub && (
                    <ul style={{
                      position: 'absolute',
                      top: 60,
                      left: 0,
                      background: '#fff',
                      boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
                      borderRadius: 8,
                      padding: '8px 0',
                      minWidth: 360,
                      zIndex: 1000,
                      listStyle: 'none',
                      margin: 0
                    }}>
                      {menu.sub.map((sub) => (
                        <li key={sub.label}>
                          <Link
                            to={sub.link}
                            style={{
                              display: 'block',
                              padding: '12px 24px',
                              color: '#29225C',
                              textDecoration: 'none',
                              fontSize: '1rem',
                              borderRadius: 4,
                              transition: 'background 0.2s',
                              textTransform: 'uppercase',
                              fontWeight: 600,
                              letterSpacing: '1px'
                            }}
                            onClick={() => setActiveMenu(null)}
                          >
                            {sub.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              ) : (
                <Link
                  to={menu.link}
                  style={{
                    margin: '0 16px',
                    color: '#29225C',
                    background: 'none',
                    border: 'none',
                    fontSize: '1.08rem',
                    fontWeight: 700,
                    cursor: 'pointer',
                    padding: 0,
                    height: '60px',
                    lineHeight: '60px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    textDecoration: 'none',
                    textTransform: 'uppercase', // 대문자 변환
                    letterSpacing: '1.2px'
                  }}
                  onClick={() => setActiveMenu(null)}
                >
                  {menu.label}
                </Link>
              )}
            </div>
          ))}
        </nav>
        
        {/* 데스크톱 언어 변경 버튼 */}
        {!isMobile && (
          <button
            onClick={() => setLang(lang === 'ko' ? 'en' : 'ko')}
            style={{
              background: '#29225C',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              padding: '6px 16px',
              fontWeight: 600,
              cursor: 'pointer',
              fontSize: '0.95rem'
            }}
          >
            {LANG_LABELS[lang]}
          </button>
        )}
      </div>
      
      {/* 모바일 메뉴 */}
      {isMobile && isMobileMenuOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: '#fff',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          padding: '20px',
          zIndex: 1000
        }}>
          {menuData.map((menu, idx) => (
            <div key={menu.label} style={{ marginBottom: '15px' }}>
              {menu.sub ? (
                <div>
                  <button
                    style={{
                      width: '100%',
                      textAlign: 'left',
                      color: '#29225C',
                      background: 'none',
                      border: 'none',
                      fontSize: '1.1rem',
                      fontWeight: 700,
                      cursor: 'pointer',
                      padding: '10px 0',
                      textTransform: 'uppercase',
                      letterSpacing: '1.2px'
                    }}
                    onClick={() => {
                      navigate(menu.link);
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    {menu.label}
                  </button>
                  {menu.sub.map((sub) => (
                    <Link
                      key={sub.label}
                      to={sub.link}
                      style={{
                        display: 'block',
                        padding: '8px 20px',
                        color: '#666',
                        textDecoration: 'none',
                        fontSize: '0.95rem',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: '1px'
                      }}
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      {sub.label}
                    </Link>
                  ))}
                </div>
              ) : (
                <Link
                  to={menu.link}
                  style={{
                    display: 'block',
                    color: '#29225C',
                    fontSize: '1.1rem',
                    fontWeight: 700,
                    cursor: 'pointer',
                    padding: '10px 0',
                    textDecoration: 'none',
                    textTransform: 'uppercase',
                    letterSpacing: '1.2px'
                  }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {menu.label}
                </Link>
              )}
            </div>
          ))}
          
          {/* 모바일 언어 변경 버튼 */}
          <button
            onClick={() => {
              setLang(lang === 'ko' ? 'en' : 'ko');
              setIsMobileMenuOpen(false);
            }}
            style={{
              width: '100%',
              background: '#29225C',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              padding: '12px 16px',
              fontWeight: 600,
              cursor: 'pointer',
              fontSize: '1rem',
              marginTop: '10px'
            }}
          >
            {LANG_LABELS[lang]}
          </button>
        </div>
      )}
    </header>
  );
}

export default Header;